/**
 * @generated SignedSource<<386faf357d58bab99755768874edd72a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MediaListCardImage_instagramMedia$data = {
  readonly id: string;
  readonly mediaUrl: string | null | undefined;
  readonly " $fragmentType": "MediaListCardImage_instagramMedia";
};
export type MediaListCardImage_instagramMedia$key = {
  readonly " $data"?: MediaListCardImage_instagramMedia$data;
  readonly " $fragmentSpreads": FragmentRefs<"MediaListCardImage_instagramMedia">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MediaListCardImage_instagramMedia",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mediaUrl",
      "storageKey": null
    }
  ],
  "type": "InstagramMediaType",
  "abstractKey": null
};

(node as any).hash = "1dcbc8376e2b27b91268fd4addf1f19a";

export default node;
